import React from 'react';
import { FileInput, Image as ImageIcon, PlusCircle, Rows3, Type, Youtube } from 'lucide-react';
import { useEditor } from './contexto';

/**
 * Barra para añadir cosas. En escritorio flota al lado de la tarjeta activa (como Google Forms: lo
 * nuevo aparece justo después de lo que estás editando); en el teléfono va fija abajo.
 */
export default function BarraFlotante({ top, movil }) {
  const ed = useEditor();
  const acciones = [
    { id: 'pregunta', texto: 'Añadir pregunta', Icono: PlusCircle, onClick: () => ed.agregarNuevo('opcion_multiple') },
    { id: 'importar', texto: 'Importar preguntas', Icono: FileInput, onClick: () => ed.abrirDialogo('importar') },
    { id: 'titulo', texto: 'Añadir título y descripción', Icono: Type, onClick: () => ed.agregarNuevo('titulo') },
    { id: 'imagen', texto: 'Añadir imagen', Icono: ImageIcon, onClick: () => ed.agregarImagen() },
    { id: 'video', texto: 'Añadir vídeo', Icono: Youtube, onClick: () => ed.agregarNuevo('video') },
    { id: 'seccion', texto: 'Añadir sección', Icono: Rows3, onClick: () => ed.agregarNuevo('seccion') },
  ];
  return (
    <div
      className={`fe-barra-flotante ${movil ? 'is-movil' : ''}`}
      style={movil ? undefined : { transform: `translateY(${top}px)` }}
      role="toolbar"
      aria-label="Añadir al formulario"
      // Que pulsar un botón no le quite la tarjeta activa (el mousedown burbujea hasta el lienzo)
      onMouseDown={(e) => e.stopPropagation()}
    >
      {acciones.map(({ id, texto, Icono, onClick }) => (
        <button key={id} type="button" className="fe-barra-btn" onClick={onClick} aria-label={texto} title={texto}>
          <Icono />
        </button>
      ))}
    </div>
  );
}
